<template>
  <Widget
    title="CLIENTES"
    title-link="/page/prospects/list"
    actionLabel="CREAR"
    :indicators="indicators"
    @action="action"
  />
</template>

<script setup>
import {
  ref,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import useApi from '@/shared/composables/useApi';
import { useProspectStore } from '../../prospects/stores/prospect_store';
import Widget from './base/indicator.vue';

const router = useRouter();
const { isLoading, apiGet } = useApi();
const { showNewModal } = useProspectStore();

const emit = defineEmits(['action']);

function action() {
  showNewModal();
  router.push('/page/prospects/list');
}

const indicators = ref([]);

const fetchData = async () => {
  const result = await apiGet('/dashboard/clientes');
  indicators.value = result.data;
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.widget-card {
  margin: 10px;
}

.indicator {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

.label {
  font-weight: 600;
}

.value {
  text-align: right;
  /* Alinea el valor a la derecha */
  /* font-size: 1.2em; */
}
</style>
